import { Grid, Stack } from "@mui/material";
import React from "react";
import AuthLogin from "../../components/login/AuthLogin";
import AuthWrapper from "../../components/login/AuthWrapper";

const Logo = require("../../assets/images/logoTrixie.png");
function Login() {
  return (
    <AuthWrapper>
      <Grid
        container
        spacing={3}
        style={{
          background: "linear-gradient(135deg, #1e2023, #2b3038)",
          borderRadius: "30px",
          padding: "2rem",
          margin: 0,
        }}
      >
        <Grid item xs={12} style={{ padding: 0 }}>
          <Stack alignItems="center">
            <img src={Logo} alt={"Logo Trixie"} style={{ maxWidth: "40%" }} />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <AuthLogin />
        </Grid>
      </Grid>
    </AuthWrapper>
  );
}

export default Login;
